import { render, staticRenderFns } from "./omzet-agen-summary.vue?vue&type=template&id=1c6ead08&"
import script from "./omzet-agen-summary.vue?vue&type=script&lang=js&"
export * from "./omzet-agen-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports